<div class="db-add-tax-rate" [formGroup]="addTaxRateForm">
  <h1>Add “{{(( (taxRate?.class || taxRateClass) | replaceTextWithBracers: { old: '-', new: ' '} ) | lowerCaseSpecificWords)}}" tax rate</h1>
  <div class="db-add-tax-rate__items mt40">
    <div class="ds-input-wrap">
      <ds-dropdown *ngIf="additionalCountries?.length"
                   formControlName="country"
                   [dsDropdownOptions]="countriesList"
                   [dsDropdownSearch]="true"
                   [dsDropdownKeepInputValue]="true"
                   [dsDropdownSelectedInputHolder]="true"
                   [dsDropdownPlaceHolder]="'text_all' | dbText"
                   (onOptionChoose)="chooseCountry($event, true)"
                   [dsDropdownLabel]="'text_countryCode' | dbText"></ds-dropdown>
    </div>
    <div class="ds-input-wrap">
      <ds-dropdown *ngIf="additionalCountries?.length && statesList?.length > 1"
                   [dsDropdownOptions]="statesList" formControlName="state"
                   [dsDropdownSearch]="true"
                   [dsDropdownKeepInputValue]="true"
                   [dsDropdownSelectedInputHolder]="true"
                   [dsDropdownPlaceHolder]="'text_all' | dbText"
                   (onOptionChoose)="chooseState($event)"
                   [dsDropdownLabel]="'text_stateCode' | dbText"></ds-dropdown>

      <span *ngIf="(statesList?.length === 1)" class="ds-input-label">{{ 'text_stateCode' | dbText }}</span>
      <input *ngIf="(statesList?.length === 1)" type="text" class="ds-input" [placeholder]="'text_all' | dbText" formControlName="state">
    </div>
    <div class="ds-input-wrap">
      <span class="ds-input-label">{{ 'text_postcodeZip' | dbText }}</span>
      <input type="text" class="ds-input" [placeholder]="'text_all' | dbText" formControlName="postcode">
    </div>
  </div>
  <div class="db-add-tax-rate__items mt9">
    <div class="ds-input-wrap">
      <span class="ds-input-label">{{ 'text_city' | dbText }}</span>
      <input type="text" class="ds-input" [placeholder]="'text_all' | dbText" formControlName="city">
    </div>
    <div class="ds-input-wrap">
      <span class="ds-input-label">{{ 'text_ratePercent' | dbText }}</span>
      <input type="text" class="ds-input" placeholder="0" formControlName="rate">
    </div>
    <div class="ds-input-wrap">
      <span class="ds-input-label">{{ 'text_taxName' | dbText }}</span>
      <input type="text" class="ds-input" [placeholder]="'text_taxName' | dbText" formControlName="name">
    </div>
  </div>
  <div class="db-add-tax-rate__items mt9">
    <div class="ds-input-wrap">
      <span class="ds-input-label">{{ 'text_priority' | dbText }}</span>
      <input type="text" class="ds-input" placeholder="1" formControlName="priority">
    </div>
    <div class="ds-input-wrap pb0">
      <input class="ds-checkbox" type="checkbox" id="compound" formControlName="compound" >
      <label for="compound">{{ 'text_compound' | dbText }}</label>
    </div>
    <div class="ds-input-wrap pb0">
      <input class="ds-checkbox" type="checkbox" id="shipping" formControlName="shipping" >
      <label for="shipping">{{ 'text_shipping' | dbText }}</label>
    </div>
  </div>
  <div class="db-add-tax-rate__btns mt9">
    <button class="ds-btn mr20" type="button" [ngClass]="{'ds-btn-disabled': loading}" (click)="closeDialog()">
      <span>{{ 'text_cancel' | dbText }}</span>
    </button>
    <a class="ds-btn-black" [ngClass]="{'ds-btn-disabled': loading}"
       (click)="taxRate?.id ? updateRate(taxRate?.id) : addTaxRate()">
      <span *ngIf="!loading">{{taxRate?.id ? ('text_update' | dbText) : ('text_addRate' | dbText)}}</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </a>
  </div>
</div>
<db-loading-screen [pageBlocker]="true" *ngIf="!!loadingPage"></db-loading-screen>
